<template>
  <div class="pa-0 bottom-sheet-tab-content" style="height: 584px; overflow-y: auto;">
	<v-layout v-if="active">
    <v-flex xs5>
      <vod-editor :uuid="id" :use-save-dialog="true"></vod-editor>
    </v-flex>
    <v-flex xs7>
  		<v-card-text class="pa-0" style="height: 568px; overflow-y: auto;">
        <clips :uuid="id"></clips>
		  </v-card-text>
    </v-flex>
	</v-layout>
  </div>
</template>

<script>
import Clips from '@/components/cloudrec/Clips.vue'
import VodEditor from '@/components/cloudrec/Vod.vue'

export default {
	props: ["id"],
  components: {
    Clips,
    VodEditor
  },
  data () {
    return {
      active: this.$route.query.tab == "clips"
    }
  },
  watch: {
    "$route.query.tab" (newVal) {
      if(newVal == "clips") {
        setTimeout(() => {
          this.active = true;
        },200);
      }
    }
  }
}
</script>
